import { render, staticRenderFns } from "./BtnEdit.vue?vue&type=template&id=6eb6c620&scoped=true"
import script from "./BtnEdit.vue?vue&type=script&lang=js"
export * from "./BtnEdit.vue?vue&type=script&lang=js"
import style0 from "./BtnEdit.vue?vue&type=style&index=0&id=6eb6c620&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb6c620",
  null
  
)

export default component.exports